function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* eslint-disable react/prop-types */


import React from 'react';
import ShapeRect from '../shapes/Rect';
import ShapeCircle from '../shapes/Circle';
import valueOrIdentity from './valueOrIdentity';
export default function renderShape(_ref) {
  var _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'rect' : _ref$shape,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? valueOrIdentity : _ref$fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? valueOrIdentity : _ref$size,
      width = _ref.width,
      height = _ref.height,
      label = _ref.label,
      _ref$shapeStyle = _ref.shapeStyle,
      shapeStyle = _ref$shapeStyle === void 0 ? function () {
    return (
      /** x */
      undefined
    );
  } : _ref$shapeStyle;
  var props = {
    width: width,
    height: height,
    label: label,
    fill: fill(_extends({}, label)),
    size: size(_extends({}, label)),
    style: shapeStyle(_extends({}, label))
  };

  if (typeof shape === 'string') {
    if (shape === 'rect') {
      return React.createElement(ShapeRect, props);
    }

    return React.createElement(ShapeCircle, props);
  }

  if (React.isValidElement(shape)) {
    return React.cloneElement(shape, props);
  }

  return React.createElement(shape, props);
}